<template>
  <v-container>
    <page-title title="Billing Details">
    </page-title>

    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-title>
          Billing Contact
        </v-card-title>
        <v-card-text>
          <v-select v-model="form.owner_id"
                    :items="activeUsers"
                    item-value="id"
                    item-text="name"
                    label="Billing Contact"
                    placeholder=" ">
          </v-select>

          <v-text-field v-model="form.name"
                        label="Company Name"
                        placeholder=" "
                        autocomplete="off"
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('billing_country')">
          </v-text-field>
        </v-card-text>

        <v-card-title>
          Billing Address
        </v-card-title>
        <v-card-text>


          <v-autocomplete v-model="form.billing_country"
                          :items="countries"
                          item-value="alpha2"
                          item-text="name"
                          autocomplete="off"
                          :rules="[rules.required]"
                          :error-messages="form.errors.get('billing_country')">
          </v-autocomplete>

          <v-text-field v-model="form.billing_address"
                        label="Address"
                        placeholder=" "
                        autocomplete="off"
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('billing_address')">
          </v-text-field>

          <v-text-field v-model="form.billing_address_line_2"
                        label="Address line 2"
                        placeholder=" "
                        autocomplete="off"
                        :error-messages="form.errors.get('billing_address')">
          </v-text-field>

          <v-text-field v-model="form.billing_city"
                        label="City"
                        placeholder=" "
                        autocomplete="off"
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('billing_city')">
          </v-text-field>

          <v-autocomplete v-if="form.billing_country === 'US'"
                          v-model="form.billing_state"
                          :items="states"
                          item-value="id"
                          item-text="name"
                          label="State"
                          placeholder=" "
                          autocomplete="off"
                          :rules="[rules.required]"
                          :error-messages="form.errors.get('billing_state')">
          </v-autocomplete>

          <v-text-field v-else
                        v-model="form.billing_state"
                        label="State/Region"
                        placeholder=" "
                        autocomplete="off"
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('billing_state')">
          </v-text-field>

          <v-text-field v-model="form.billing_zip"
                        label="ZIP Code"
                        placeholder=" "
                        autocomplete="off"
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('billing_zip')">
          </v-text-field>


        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Confirm Billing Details
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import PageTitle from '../../components/PageTitle';
import dataService from '../../../../ml/services/dataService';
import formValidation from '../../plugins/formValidation';

export default {
  mixins: [formValidation],
  components: {PageTitle},
  data() {
    return {
      countries: dataService.getCountries(),
      form: new Form({
        owner_id: '',
        name: '',
        billing_address: '',
        billing_address_line_2: '',
        billing_city: '',
        billing_state: '',
        billing_zip: '',
        billing_country: '',
      }),
      states: dataService.getStates(),
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'team',
      'user',
      'users',
    ]),
  },
  created() {
    this.initForm();
    this.fetchData();
  },
  methods: {
    initForm() {
      this.form.owner_id = this.team.owner_id;
      this.form.name = this.team.name;
      this.form.billing_address = this.team.billing_address;
      this.form.billing_address_line_2 = this.team.billing_address_line_2;
      this.form.billing_city = this.team.billing_city;
      this.form.billing_state = this.team.billing_state;
      this.form.billing_zip = this.team.billing_zip;
      this.form.billing_country = this.team.billing_country;
    },
    fetchData() {

    },
    async submit() {
      if (this.form.busy) {
        return;
      }
      await this.form.put(`/api/teams/${this.team.id}/billing-address`)

      await this.form.put(`/api/teams/${this.team.id}/owner`)

      await this.$store.dispatch('fetchUser');

      this.$router.push({name: 'subscription'});
    }
  }
}
</script>
